import { useQuery } from '@tanstack/react-query';
import { getBatches } from '../requests';
import type { Batch } from '../types';

export type UseGetBatchesParams = {
  batchId?: string;
  refetchInterval: (data: any | Batch) => number | false;
};

export const useGetBatches = ({ batchId, ...options }: UseGetBatchesParams) =>
  useQuery({
    queryKey: ['batches', [batchId]],
    queryFn: () => getBatches({ pathParams: { userBatchId: batchId! } }),
    enabled: !!batchId,
    ...options,
  });
